/** Exterior registration, with rooftop assignment reviewed 31 October 2026.
 * Display positions remain separate from the original site reference coordinates.
 * Exact mounting centres, installed variants and surveyed dimensions remain unknown.
 */
export interface RfimsModelPlacement {
  lat: number;
  lon: number;
  /** Clockwise compass bearing of the model's reference column; zero is true north. */
  headingDeg: number;
  support: 'trailer' | 'pads' | 'roof';
  roofBuildingId?: number;
  /** Roof height above local ground, used only while mapped roof data is unavailable. */
  roofHeightM?: number;
  evidence: string;
}

export const RFIMS_MODEL_PLACEMENTS: Record<string, RfimsModelPlacement> = {
  rfims00: {
    lat: 40.137248, lon: -105.255193, headingDeg: 0, support: 'trailer',
    evidence: 'Visible mast and support platform north-east of the supplied A4 point. Exterior uses the documented RFIMS family as a reference; installed dimensions remain illustrative.',
  },
  rfims02: {
    lat: 37.945761, lon: -75.461250, headingDeg: 0, support: 'trailer',
    evidence: 'Mast/support assembly south-west of the site reference, beside the receiving-dish compound. Site review confirmed the displayed location. Coordinates remain imagery estimates; the north-aligned reference column is not an installed column-number assignment.',
  },
  rfims10: {
    lat: 21.36565277159445, lon: -157.96281106834144, headingDeg: 0, support: 'roof',
    roofBuildingId: 370977021, roofHeightM: 18.61,
    evidence: 'RFIMS is positioned at 21.36565277159445, -157.96281106834144 on the east rooftop shelter at the Daniel K. Inouye Regional Center. Placement was corrected on 31 October 2026. The separate 2.4 m antenna is on the west shelter. Roof elevation follows the local lidar model; mounting dimensions and installed heading remain unmeasured. This supersedes the earlier approximate shelter centre and ground-level candidate.',
  },
};

export const RFIMS_PLACEMENT_SOURCE = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer';
